import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';
import { CompanyCreate } from 'src/types/companies';

export class CompaniesRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getCompanies(
    params?: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/company/all`,
      params,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async importCompanies(
    companies?: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `partners/company/import-companies`,
      body: companies,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async create(
    body: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `partners/company/create`,
      body,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async getFreeRedeems(): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/company/redeems`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async getCompanyById(
    id: string
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `partners/company/find/${id}`,
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async update(
    body: CompanyCreate,
    id: string
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `partners/company/update`,
      body: {
        ...body,
        _id: id,
      },
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }
}
